import { getBrowserTimezone } from '~/lib/DateTime.js';
import useCurrentBusiness from '~/lib/useCurrentBusiness.jsx';
import { DateTime } from 'luxon';

const BookingTimeZone = ({ clientTz }) => {
    const browserTz = getBrowserTimezone();
    const business = useCurrentBusiness();
    const businessTz = business?.timezone;

    // Everything all matchy? No need to be verbose
    if (clientTz === browserTz && businessTz === browserTz) {
        return null;
    }

    const dateTime = DateTime.local({ zone: clientTz });

    // Format the DateTime to display the human-readable time zone name
    const humanTimezone =
        dateTime.toFormat('ZZZZZ') + ' (UTC ' + dateTime.toFormat('ZZ') + ')';

    return (
        <div className="text-sm text-gray-500 mb-2 text-right" title={clientTz}>
            Times shown in {humanTimezone}
        </div>
    );
};

export default BookingTimeZone;
